// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SpinnerMini_spinner__vgHHQ","quiver-spinner__spin":"SpinnerMini_quiver-spinner__spin__tzcPH"};